export default "__VITE_PUBLIC_ASSET__0f340d91__"